<template>
    <div class="error">
        <div class="errorDiv">
            <el-row>
                <el-col :span="14">
                    <div style="text-align:center;height:100%"><img src="@/assets/images/404.png" alt=""></div>
                </el-col>
                <el-col :span="10">
                    <p>{{$store.state.lang.sorryError}}</p>   <!-- 对不起，当前页面发生错误！-->
                    <span>{{$store.state.lang.checkUrl}}</span>  <!-- 请检查您输入的网址是否正确，点击以下按钮返回 -->                   
                    <router-link to="/">
                        <el-button type="primary" round>{{$store.state.lang.back}}</el-button>  <!-- 返回首页！-->
                    </router-link>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import store from "@/vuex/store";
    export default {
        data() {
            return {   };
        },
        store
    }
</script>

<style scoped>
.error{
    position: absolute;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
}
.errorDiv{
    width: 100%;
    height: 100%;
    margin: auto;
    position: relative;
}
.el-row{
  width: 1100px;
  position: fixed;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
}
p{
    font-size: 24px;
    padding: 90px 0 15px 0;
    font-weight: 700;
}
span{
    display: block;
    color: grey;
    margin-bottom: 30px;
    font-size: 14px;
}
.el-button{
    background: #1482f0;
    height: 38px;
    border: none;
}
</style>


// WEBPACK FOOTER //
// src/views/Error.vue